// extracted by mini-css-extract-plugin
export default {"saved-address-sec":"SavedAddress_saved-address-sec__Rkg56"};